//插入视频
angular.module('insertVideoModule', []).
controller("insertVideoCtrl", ["$scope", "trsHttpService", "$modalInstance", "$window", "localStorageService", "globleParamsSet", "$sce", function($scope, trsHttpService, $modalInstance, $window, localStorageService, globleParamsSet, $sce) {
    initStatus();
    $scope.close = function() {
        $modalInstance.dismiss();
    };
    $window.addEventListener("storage", function(e) {
        if (angular.isDefined(localStorageService.get("ue.video"))) {
            $modalInstance.close(localStorageService.get("ue.video"));
        }
    });

    function initStatus() {
        localStorageService.remove("ue.video");
        $scope.data = {
            iframeUrl: $sce.trustAsResourceUrl(trsHttpService.getMasUrl() + "/mas/openapi/pages.do?method=list&appKey=" + trsHttpService.getMasConfig())
        };
    }
    ueditor_closeMas = function() {
        $modalInstance.dismiss();
    };
}])